import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from 'src/app/services/shared/loading.service';
import { environment } from 'src/environments/environment';
declare var google: any;
declare var gapi: any;

@Component({
  selector: 'apc-sheet-export',
  templateUrl: './sheet-export.component.html',
  styleUrls: ['./sheet-export.component.scss'],
})
export class SheetExportComponent implements OnInit {
  public tokenValid: boolean;
 
  constructor(public translate: TranslateService, private router: Router, public loadingService: LoadingService) { }
  @Output() exportSheetEvent = new EventEmitter<boolean>();
  @Output() getToken = new EventEmitter(false);
  @Input() expanded;

  public API_KEY = environment.googleApiKey;
  public CLIENT_ID = environment.googleAuthClientId;
  public SCOPE = 'https://www.googleapis.com/auth/drive.file';

  public tokenClient;
  public  gapiInited;
  public gisInited;


  ngOnInit(): void {
    this.gisInited = false;
    this.gapiInited = false;
    this.gisInit();
    this.gapiLoad();
  }
  async gisInit() {
    this.tokenClient = await google.accounts.oauth2.initTokenClient({
      client_id: this.CLIENT_ID,
      scope: this.SCOPE,
      callback: '',  // defined at request time
      error_callback:(er)=>this.errorCallback(er),
    });
    this.gisInited = true;
    this.checkBeforeStart();
  }
 errorCallback(err){
  this.loadingService.popLoadingRequests();
 }
 async gapiLoad() {
    await gapi.load('client', this.gapiInit.bind(this));
  }
  async  gapiInit() {
    await gapi.client.init({});
    await gapi.client.load('https://sheets.googleapis.com/$discovery/rest?version=v4');
    this.gapiInited = true;
    this.checkBeforeStart();   
  }

  checkBeforeStart() {
    if (this.gapiInited && this.gisInited) {
      // Start only when both gapi and gis are initialized.
      this.getToken.emit(this.tokenClient);
      this.tokenValid=true;
    }
  }



}
